module.exports = __webpack_public_path__ + "images/emoji/tired_face.fda321161b8fc061faed.png";